import state from "@/store/modules/group/state";
import actions from "@/store/modules/group/actions";
import mutations from "@/store/modules/group/mutations";
import getters from "@/store/modules/group/getters";


export default {
  state,
  actions,
  mutations,
  getters
}